/** Returns true if `matcher` is of type [[DateInterval]]. */
export function isDateInterval(matcher) {
    return Boolean(matcher &&
        typeof matcher === 'object' &&
        'before' in matcher &&
        'after' in matcher);
}
//# sourceMappingURL=isDateInterval.js.map